import { render, staticRenderFns } from "./Sys.vue?vue&type=template&id=9c928d7a&"
import script from "./Sys.vue?vue&type=script&lang=js&"
export * from "./Sys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports